import { render } from "./RecordTable.vue?vue&type=template&id=e177f4e2"
import script from "./RecordTable.vue?vue&type=script&lang=js"
export * from "./RecordTable.vue?vue&type=script&lang=js"
script.render = render

export default script